import * as firebase from "firebase/app";
import { getEnv } from "../helpers/env";

export const analytics = (event = "", param) => {
  firebase.analytics().logEvent(event, { ...param, platform: "web" });
};

export const setUserProperties = prop => {
  firebase.analytics().setUserProperties(prop);
};

export const setUserId = prop => {
  firebase.analytics().setUserId(prop);
};

export const getFirebaseCofig = () => {
  if (getEnv("ANALYTICS").toLowerCase() == "dev") {
    return {
      apiKey: "AIzaSyBwwdVvUQHOkTkAmZoaCgX99hO56qfJ8Xc",
      authDomain: "ausbiz-ott2020.firebaseapp.com",
      databaseURL: "https://ausbiz-ott2020.firebaseio.com",
      projectId: "ausbiz-ott2020",
      storageBucket: "ausbiz-ott2020.appspot.com",
      messagingSenderId: "452577922512",
      appId: "1:452577922512:web:93ea93be0ef2e4af0c7dd5",
      measurementId: "G-HZRSEBBSVE"
    };
  }
  return {
    apiKey: "AIzaSyBwwdVvUQHOkTkAmZoaCgX99hO56qfJ8Xc",
    authDomain: "ausbiz-ott2020.firebaseapp.com",
    databaseURL: "https://ausbiz-ott2020.firebaseio.com",
    projectId: "ausbiz-ott2020",
    storageBucket: "ausbiz-ott2020.appspot.com",
    messagingSenderId: "452577922512",
    appId: "1:452577922512:web:fd55bba9edb363d60c7dd5",
    measurementId: "G-RESPYX4P2H"
  };
};
